module.exports = __webpack_public_path__ + "img/4_175.5b779f86.png";